import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogErrorComponent } from './dialog-error.component';
import { DialogModule, ButtonModule, SpinnerModule } from '@apps/ui';

@NgModule({
  declarations: [DialogErrorComponent],
  entryComponents: [DialogErrorComponent],
  imports: [CommonModule, DialogModule, ButtonModule, SpinnerModule],
  exports: [DialogModule]
})
export class DialogErrorModule {}
